import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const Stop = ({ tripId, idx, name, value, onSaved }) => {
  const [v, setV] = useState(value ?? "");
  const save = async () => {
    if ((value ?? "") === v.trim()) return;
    try { await api.patch(`/admin/trips/${tripId}/platforms`, { stop_idx: idx, platform: v }); toast.success(`Dársena de ${name.split(" · ")[0]} guardada`); onSaved(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <label className="flex items-center justify-between gap-2 rounded-xl bg-white px-3 py-2 text-sm ring-1 ring-black/5">
      <span className="truncate">{name}</span>
      <input data-testid={`platform-${idx}`} value={v} onChange={(e) => setV(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} placeholder="—" maxLength={20} className="h-8 w-20 rounded-lg border border-black/10 px-2 text-center font-mono" />
    </label>
  );
};

export const PlatformsEditor = ({ d, onSaved }) => {
  const stops = (d.route?.stops ?? []).slice(0, -1);
  const used = new Set((d.bookings ?? []).map((b) => b.from_idx));
  const list = stops.map((s, i) => ({ s, i })).filter(({ i }) => i === 0 || used.has(i) || d.trip.platforms?.[i]);
  return (
    <div data-testid="trip-platforms">
      <p className="mb-1 font-display-up text-lg">Dársenas de salida</p>
      <p className="mb-2 text-xs text-[var(--muted-ink)]">Se avisa a cada pasajero por email unos 30 minutos antes de subir. Si no cargás la dársena, el aviso dice que la consulte en boletería.</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {list.map(({ s, i }) => <Stop key={`${i}-${d.trip.platforms?.[i] ?? ""}`} tripId={d.trip.id} idx={i} name={s.name} value={d.trip.platforms?.[i]} onSaved={onSaved} />)}
      </div>
    </div>
  );
};
